/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface SamaTaskData
 *
 */
// create custom validators for the regexes
export interface SamaTaskData {
    /**
     *
     * #type number
     * #memberof SamaTaskData
        * @type int
        
         */
    id: number;
    /**
     * A URL which allows anyone in possession of said URL for the time specified by the expiresIn query param to access the resource
     * #type string
     * #memberof SamaTaskData
        
        
         */
    url: string;
    /**
     * A URL which allows anyone in possession of said URL for the time specified by the expiresIn query param to access the resource
     * #type string
     * #memberof SamaTaskData
        
        
         */
    image?: string;
    /**
     * The original fileName of the sample. This is unique within a dataset
     * #type string
     * #memberof SamaTaskData
        
        
         */
    lightlyFileName?: string;
    /**
     *
     * #type string
     * #memberof SamaTaskData
        
        
         */
    lightlyMetaInfo?: string;
}
/**
 * Check if a given object implements the SamaTaskData interface.
 */
export function instanceOfSamaTaskData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "url" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const SamaTaskDataTypiaAssertEquals = (input: any) => {
    return ((input: any): SamaTaskData => {
        const __is = (input: any, _exceptionable: boolean = true): input is SamaTaskData => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.id && Math.floor(input.id) === input.id && (-2147483648 <= input.id && input.id <= 2147483647) && "string" === typeof input.url && (undefined === input.image || "string" === typeof input.image) && (undefined === input.lightlyFileName || "string" === typeof input.lightlyFileName) && (undefined === input.lightlyMetaInfo || "string" === typeof input.lightlyMetaInfo) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "url", "image", "lightlyFileName", "lightlyMetaInfo"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is SamaTaskData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.id && (Math.floor(input.id) === input.id || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "number (@type int)",
                    value: input.id
                })) && (-2147483648 <= input.id && input.id <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "number (@type int)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "number",
                    value: input.id
                })) && ("string" === typeof input.url || $guard(_exceptionable, {
                    path: _path + ".url",
                    expected: "string",
                    value: input.url
                })) && (undefined === input.image || "string" === typeof input.image || $guard(_exceptionable, {
                    path: _path + ".image",
                    expected: "(string | undefined)",
                    value: input.image
                })) && (undefined === input.lightlyFileName || "string" === typeof input.lightlyFileName || $guard(_exceptionable, {
                    path: _path + ".lightlyFileName",
                    expected: "(string | undefined)",
                    value: input.lightlyFileName
                })) && (undefined === input.lightlyMetaInfo || "string" === typeof input.lightlyMetaInfo || $guard(_exceptionable, {
                    path: _path + ".lightlyMetaInfo",
                    expected: "(string | undefined)",
                    value: input.lightlyMetaInfo
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "url", "image", "lightlyFileName", "lightlyMetaInfo"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "SamaTaskData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "SamaTaskData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const SamaTaskDataTypiaAssertStringify = (input: SamaTaskData): string => {
    return ((input: any): string => { const assert = (input: any): SamaTaskData => {
        const __is = (input: any): input is SamaTaskData => {
            const $io0 = (input: any): boolean => "number" === typeof input.id && !Number.isNaN(input.id) && Math.floor(input.id) === input.id && (-2147483648 <= input.id && input.id <= 2147483647) && "string" === typeof input.url && (undefined === input.image || "string" === typeof input.image) && (undefined === input.lightlyFileName || "string" === typeof input.lightlyFileName) && (undefined === input.lightlyMetaInfo || "string" === typeof input.lightlyMetaInfo);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is SamaTaskData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.id && !Number.isNaN(input.id) && (Math.floor(input.id) === input.id || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "number (@type int)",
                    value: input.id
                })) && (-2147483648 <= input.id && input.id <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "number (@type int)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "number",
                    value: input.id
                })) && ("string" === typeof input.url || $guard(_exceptionable, {
                    path: _path + ".url",
                    expected: "string",
                    value: input.url
                })) && (undefined === input.image || "string" === typeof input.image || $guard(_exceptionable, {
                    path: _path + ".image",
                    expected: "(string | undefined)",
                    value: input.image
                })) && (undefined === input.lightlyFileName || "string" === typeof input.lightlyFileName || $guard(_exceptionable, {
                    path: _path + ".lightlyFileName",
                    expected: "(string | undefined)",
                    value: input.lightlyFileName
                })) && (undefined === input.lightlyMetaInfo || "string" === typeof input.lightlyMetaInfo || $guard(_exceptionable, {
                    path: _path + ".lightlyMetaInfo",
                    expected: "(string | undefined)",
                    value: input.lightlyMetaInfo
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "SamaTaskData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "SamaTaskData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: SamaTaskData): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $so0 = (input: any): any => `{${undefined === input.image ? "" : `"image":${undefined !== input.image ? $string(input.image) : undefined},`}${undefined === input.lightlyFileName ? "" : `"lightlyFileName":${undefined !== input.lightlyFileName ? $string(input.lightlyFileName) : undefined},`}${undefined === input.lightlyMetaInfo ? "" : `"lightlyMetaInfo":${undefined !== input.lightlyMetaInfo ? $string(input.lightlyMetaInfo) : undefined},`}"id":${input.id},"url":${$string(input.url)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const SamaTaskDataValidatorShape = {
    'id': yup.number().integer().defined(),
    'url': yup.string().defined(),
    'image': yup.string(),
    'lightlyFileName': yup.string(),
    'lightlyMetaInfo': yup.string(),
};
export const SamaTaskDataValidator = yup.object().shape(SamaTaskDataValidatorShape);
export const SamaTaskDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'integer',
    } as unknown as fastJSON.IntegerSchema,
    'url': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'image': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'lightlyFileName': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'lightlyMetaInfo': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const SamaTaskDataStringifyShape: ObjectSchema = {
    title: 'SamaTaskData Stringifier',
    type: 'object',
    properties: {
        ...SamaTaskDataStringifyShapeProperties
    },
    required: [
        'id',
        'url',
    ],
};
export const SamaTaskDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(SamaTaskDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const SamaTaskDataStringify: (data: SamaTaskData) => string = SamaTaskDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function SamaTaskDataFromJSON(json: any): SamaTaskData {
    return SamaTaskDataFromJSONTyped(json, false);
}
export function SamaTaskDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SamaTaskData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
        'url': json['url'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'lightlyFileName': !exists(json, 'lightlyFileName') ? undefined : json['lightlyFileName'],
        'lightlyMetaInfo': !exists(json, 'lightlyMetaInfo') ? undefined : json['lightlyMetaInfo'],
    };
}
export function SamaTaskDataToJSON(value?: SamaTaskData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'url': value.url,
        'image': value.image,
        'lightlyFileName': value.lightlyFileName,
        'lightlyMetaInfo': value.lightlyMetaInfo,
    };
}
